var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(typeof _vm.value === 'string')?[_vm._v(" \""+_vm._s(_vm.value)+"\" ")]:[_vm._v(" "+_vm._s(_vm.value)+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }